// extracted by mini-css-extract-plugin
export default {"themeSwitcher":"ThemeSwitcher_themeSwitcher__IvBWm","icon":"ThemeSwitcher_icon__m-ysP"};